export type State = {
  isSceneLoaded: boolean
  isControlsEnabled: boolean

  isBagLoaded: boolean
  isAnimationFinished: boolean

  texDefaultN: string | null        // texture uuid
  texBody: string | null
  texBodyN: string | null
}

export const state: State = {
  isSceneLoaded: false,
  isControlsEnabled: false,

  isBagLoaded: false,
  isAnimationFinished: false,

  texDefaultN: null,
  texBody: null,
  texBodyN: null,
};
